import { LogoMark, Wordmark } from "./Logo";

const FOOTER_LINKS = ["Privacy", "Terms", "Contact"];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink border-t border-white/10">
    <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8">
      <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
        <div className="flex items-center gap-2.5">
          <LogoMark size={28} dark />
          <Wordmark dark className="text-lg leading-none" />
        </div>

        <div className="flex items-center gap-7">
          {FOOTER_LINKS.map((label) => (
            <a
              key={label}
              href={`#${label.toLowerCase()}`}
              data-testid={`footer-link-${label.toLowerCase()}`}
              className="group relative font-body text-sm font-medium text-white/60 transition-colors duration-300 hover:text-white"
            >
              {label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-gold transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </div>
      </div>

      <div className="mt-10 flex flex-col gap-6 border-t border-white/10 pt-8 md:flex-row md:items-end md:justify-between">
        <p
          data-testid="footer-copyright"
          className="font-mono text-xs text-white/50"
        >
          © 2026 Mortlens
        </p>
        <p
          data-testid="footer-disclaimer"
          className="max-w-xl font-body text-[12px] leading-relaxed text-white/50"
        >
          Mortlens provides estimates only — not loan offers, rate locks, or
          financial advice. Mortlens is not a lender, broker, or credit
          reporting agency. Verify all figures with your lender, county
          appraisal district, and insurer.
        </p>
      </div>
    </div>
  </footer>
);
